import React, { useState, useEffect } from 'react'
import {
  Form,
  Pagination,
  Button,
  Modal,
  FormGroup,
  FormLabel,
  FormSelect,
  Row,
  Col,
} from 'react-bootstrap'
import { FaFileExcel, FaSyncAlt, FaUserEdit } from 'react-icons/fa'
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'bootstrap/dist/css/bootstrap.min.css'
import { People, Eye, Book } from 'react-bootstrap-icons'
import ApiEndpoints,{BASE_URL, BASE_URL_Upload} from './commonComponents/ApiEndpoints'
import toast from 'react-hot-toast'
import EditStudentModal from './EditStudentModal'
import { useLocation, useNavigate } from 'react-router-dom'
import SelectableField from './commonComponents/SelectableField'
import Cookies from 'js-cookie'
import axios from 'axios'
import * as XLSX from 'xlsx'
import { useAuth } from './AuthContext'

const DataTable = () => {
  const {token} = useAuth()
  const [marginLeft, setMarginLeft] = useState(
    window.innerWidth > 768 ? '300px' : '0px',
  )
  const navigate = useNavigate()
  const [showEditModal, setShowEditModal] = useState(false)
  const [selectedCourse, setSelectedCourse] = useState(null)

  useEffect(() => {
    const handleResize = () => {
      setMarginLeft(window.innerWidth > 768 ? '270px' : '0px')
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const [user, setUser] = useState(null)

  const initialData = []

  const [data, setData] = useState(initialData)
  const [itemsPerPage, setItemsPerPage] = useState(100)
  const [search, setSearch] = useState('')
  const [currentPage, setCurrentPage] = useState(1)
  const [screenWidth, setScreenWidth] = useState(window.innerWidth)
  const [showModal, setShowModal] = useState(false)
  const [filteredData, setFilteredData] = useState([]) // Data displayed after filtering
  const [loading, setLoading] = useState(false)
  const [studentCount, setStudentCount] = useState(null)
  const [countColor, setCountColor] = useState('') // Add color for the response
  const [resetKey, setResetKey] = useState(0)
  const [students, setStudents] = useState([])
  const [selectedClass, setSelectedClass] = useState('')
  const location = useLocation()

  useEffect(() => {
    if (location.state?.newStudent) {
      setNewStudent(location.state.newStudent)
      setStudentImage(location.state.studentImage || null)

      // Clear state after using it, so it's not retained on refresh
      navigate(location.pathname, { replace: true }) // removes location.state
    }
  }, [])

  useEffect(() => {
    const institueId = Cookies.get('institute_id')
    const userCookie = Cookies.get('user')
    let token = null
    console.log('InstituteID', institueId)

    if (userCookie) {
      try {
        const user = JSON.parse(userCookie)
        token = user.token
        console.log('TOKEN:', token)
        setUser(JSON.parse(userCookie))
      } catch (err) {
        console.error(' Failed to parse user cookie', err)
      }
    } else {
      console.warn('user cookie not found')
    }

    const fetchFilteredData = async () => {
      console.log('Insti ID: ', institueId)
      try {
        const headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          institute_id: Number(institueId),
        }

        console.log('Request Headers:', headers)

        const response = await axios.get(
          BASE_URL+'/student/all',
          { headers },
        )

        console.log('Students response: ', response.data.data)
        setStudents(response.data.data)
        // setData(response.data.data)
        setFilteredData(response.data.data)
      } catch (error) {
        toast.error(error.response?.data?.message || 'Something went wrong')
      }
    }

    fetchFilteredData()
  }, [loading])

  const [selectedData, setSelectedData] = useState({})
  const fetchFilteredData = ({
    course,
    class: classId,
    student,
    admission_date,
  }) => {
    console.log('COURSE:', course)
    console.log('class:', classId)
    console.log('student:', student)
    console.log('admission_date:', admission_date)
    if (admission_date) {
      const selectedDate = new Date(admission_date).toISOString().split('T')[0]
      const filtered = students.filter((s) => {
        const studentDate = new Date(s.admission_date)
          .toISOString()
          .split('T')[0]
        return studentDate === selectedDate
      })
      setData(filtered)
    }
    // if (student) {
    //   updatedData = updatedData.filter(
    //     (item) => item?.name?.toLowerCase().includes(student.toLowerCase()),
    //     console.log('student', student),
    //   )
    // }

    if (student) {
      console.log('STUDENT AFTER SELECT:', student)
      const studentName = students.find((s) => s.id === Number(student))
      let filtered = [...students]

      console.log('STUDENT NAME:', studentName)
      if (studentName) {
        // const updatedData = studentName
        //   .toLowerCase()
        //   .includes(studentName.toLowerCase())
        // console.log('updatedData', updatedData)
        setData([studentName])
      }

      const isNumeric = /^\d+$/.test(student) // Check if input is number (ID)

      if (isNumeric) {
        console.log('Filtering by student ID')
        filtered = filtered.filter((s) => s.id === Number(student))
      } else {
        console.log('Filtering by student NAME')
        filtered = filtered.filter((s) =>
          s.name?.toLowerCase().includes(student.toLowerCase()),
        )
      }
      console.log('Filtered Students:', filtered)
      setData(filtered)
    }

    // Update the state with the filtered data
    // setFilteredStudents(updatedData)
  }

  useEffect(() => {
    let filteredStu = students
    console.log('🔵 Filtered Students:', filteredStu)

    if (selectedClass) {
      const instituteId = Cookies.get('institute_id')

      const headers = {
        institute_id: Number(instituteId),
      }

      axios
        .get(
          BASE_URL+`/get/student/by-class?class_id=${selectedClass}`,
          { headers },
        )
        .then((res) => {
          const classStudents = res.data.data || []
          console.log('Fetched Students by class:', classStudents)

          const classStudentIds = new Set(classStudents.map((stu) => stu.id))
          const filteredData = students.filter((student) =>
            classStudentIds.has(student.id),
          )

          console.log('✅ Filtered Data to Display:', filteredData)
          setFilteredData(filteredData)
          setData(filteredData) // for table
        })
        .catch((error) => {
          // This is where 404 or other errors come
          if (
            error.response?.data?.message === 'No classes found for this course'
          ) {
            console.error('No classes found for this course.')
          } else {
            console.error('Error fetching classes:', error)
            console.error('Something went wrong while fetching classes.')
          }
          setFilteredData([])

          // setFilteredStudents([])
          setClasses([])
        })
    }
  }, [students, selectedClass])

  const handleSelect = (selectedValues) => {
    setSelectedData(selectedValues)
    if (selectedValues.class) {
      const classId = selectedValues.class
      setSelectedClass(classId)
    }

    fetchFilteredData(selectedValues)
    if (selectedData.abc === 'abc') {
      console.log('Handling abc case')
    }
  }

  useEffect(() => {
    fetchFilteredData(selectedData)
  }, [selectedData])

  const totalPages = Math.ceil(filteredData.length / itemsPerPage)
  // Pagination Logic
  const indexOfLastItem = currentPage * itemsPerPage
  const indexOfFirstItem = indexOfLastItem - itemsPerPage
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem)

  useEffect(() => {
    if (currentPage > totalPages && totalPages !== 0) {
      setCurrentPage(1)
    }
  }, [filteredData, itemsPerPage, totalPages])

  const [newStudent, setNewStudent] = useState({
    name: '',
    dob: '',
    age: '',
    gender: '',
    father_name: '',
    mother_name: '',
    admission_date: '',
    admission_number: '',
    course_id: '',
    class_id: '',
    id_proof_number: '',
    id_proof_type: '',
    phone: '',
    whatsapp_number: '',
    parents_number: '',
    email: '',
    address: '',
    institute_id: '',
  })

  const [studentImage, setStudentImage] = useState(null)
  const [courseTouched, setCourseTouched] = useState(false)
  const [courses, setCourses] = useState([])
  const [classes, setClasses] = useState([])
  const [institutes, setInstitutes] = useState([])
  const [selectedNewCourse, setSelectedNewCourse] = useState([])
  const [searchAdmissionDate, setSearchAdmissionDate] = useState('')

  useEffect(() => {
    ApiEndpoints.getAllClasses().then((res) => setClasses(res.data.data))
    ApiEndpoints.getAllCourses().then((res) => setCourses(res.data.data))
    ApiEndpoints.getAllInstitutes().then((res) => setInstitutes(res.data.data))
  }, [])

  const handleCourseChange = (e) => {
    const courseId = e.target.value
    console.log('Selected course Id:', courseId)
    setCourseTouched(true)
    setSelectedNewCourse(courseId)
    setNewStudent((prev) => ({ ...prev, course_id: courseId }))
    // setClasses([])
    setStudentCount(null)
    console.log('Cleared Classes')

    if (courseId) {
      ApiEndpoints.getAllClassesByCourseId(courseId)
        .then((res) => {
          const { data } = res
          if (data.status === false || !data.data?.length) {
            toast.error('No classes found for this course.')
            setClasses([])
            setStudentCount(null)
          } else {
            setClasses(data.data)
          }
        })
        .catch((error) => {
          // This is where 404 or other errors come
          if (
            error.response?.data?.message === 'No classes found for this course'
          ) {
            // toast.error('No classes found for this course.')
            setStudentCount(null)
          } else {
            console.error('Error fetching classes:', error)
            toast.error('Something went wrong while fetching classes.')
          }
          setClasses([])
          setStudentCount(null)
        })
    }
  }
  const handleNavigateToCreateClass = () => {
    navigate('/AddClass', {
      state: {
        from: 'AddStudent',
        newStudent,
        studentImage,
        selectedNewCourse,
      },
    })
  }

  const handleClassChange = (e) => {
    const classId = e.target.value
    setNewStudent((prev) => ({ ...prev, class_id: classId }))

    // Clear previous student count
    setStudentCount(null)
    setCountColor('')

    if (classId) {
      // Call the API to get the student count for the selected class
      fetch(
        BASE_URL+`/get/class/student/count?class_id=${classId}`,{
        headers :
          {
          Authorization: `Bearer ${token}`
        }
      } 
      )
        .then((response) => response.json())
        .then((data) => {
          if (
            data?.status &&
            data?.data?.current !== undefined &&
            data?.data?.maximum_limit !== undefined
          ) {
            const current = data.data.current === null ? 0 : data.data.current // Treat null as 0
            const maximum_limit = parseInt(data.data.maximum_limit, 10) // Parse maximum_limit as a number
            setStudentCount({ current, maximum_limit }) // Set the state with correct property names
            setCountColor('green') // Example color for success
          } else {
            setStudentCount('No data available')
            setCountColor('red') // Example color for no data
          }
        })
        .catch((error) => {
          console.error('Error fetching student count:', error)
          setStudentCount('Error fetching data')
          setCountColor('red') // Example color for error
        })
    }
  }

  // Function to calculate age from date of birth
  const calculateAge = (dob) => {
    if (!dob) return ''
    const birthDate = new Date(dob)
    const today = new Date()
    let age = today.getFullYear() - birthDate.getFullYear()
    const monthDiff = today.getMonth() - birthDate.getMonth()

    // Adjust age if the birthday hasn't occurred yet this year
    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--
    }
    return age
  }
  // Handle Form Input
  const handleInputChange = (e) => {
    const { name, value } = e.target
    console.log(
      `Input Changed - Name: ${name}, Value: ${value} (Type: ${typeof value})`,
    )
    setNewStudent((prev) => ({ ...prev, [name]: value }))

    if (name === 'dob') {
      const age = calculateAge(value)
      setNewStudent((prev) => ({
        ...prev,
        dob: value,
        age: age.toString(),
      }))
    } else {
      setNewStudent((prev) => ({ ...prev, [name]: value }))
    }
  }

  const handleSave = async (e) => {
    e.preventDefault()
    try {
      setLoading(true)
      let imageUrl = null

      if (studentImage) {
        if (studentImage.size > 2 * 1024 * 1024) {
          toast.error('Image size should not exceed 2MB.')
          return
        }

        const formData = new FormData()
        formData.append('image', studentImage)
        formData.append('folder', 'student')

        for (let [key, value] of formData.entries()) {
          console.log(`${key}:`, value)
        }

        const imageResponse = await axios.post(
          BASE_URL+'/upload-image',
          formData,
        )
        imageUrl = BASE_URL_Upload + `/${imageResponse.data.path}`
        console.log('IMGURL', imageUrl)
      }
      const studentData = {
        ...newStudent,
        student_image: imageUrl,
      }
      console.log('Sending data: ', newStudent)
      const response = await ApiEndpoints.addStudent(studentData)
      toast.success(response.data.message)
      // setNewStudent('Response: ', response)

      // Reset the form after submission
      setNewStudent({
        name: '',
        dob: '',
        age: '',
        gender: '',
        father_name: '',
        mother_name: '',
        admission_date: '',
        admission_number: '',
        course_id: '',
        class_id: '',
        id_proof_type: '',
        id_proof_number: '',
        phone: '',
        whatsapp_number: '',
        parents_number: '',
        email: '',
        address: '',
        institute_id: '',
      })
      setStudentImage(null)
      setShowModal(false)
    } catch (error) {
      toast.error(error.response?.message || 'Something wents wrong.')
      setShowModal(false)
    } finally {
      setLoading(false)
    }
  }

  const handleView = (id) => {
    if (!id) {
      console.error('Student ID is undefined')
      return
    }
    console.log('Navigate to : ', `/StudentProfile/${id}`)
    navigate(`/StudentProfile/${id}`)
  }

  const handleEnrolledCourses = (id) => {
    if (!id) {
      console.error('Student id is undefined')
      return
    }

    const student = filteredData.find((item) => item.id === id)
    const studentName = student?.name
    const courseName =
      courses.find((course) => course.id === student?.course_id)?.name || 'N/A'
    const className =
      classes.find((cls) => cls.id === student?.class_id)?.class_name || 'N/A'

    console.log('Navigate to:', `/EnrolledCourses/${id}`)
    console.log('Student Name:', studentName)
    console.log('Student ID:', id)
    console.log('Course Name:', courseName)
    console.log('Class Name:', className)
    console.log('Admission Number:', student?.admission_number)

    navigate(`/EnrolledCourses/${id}`, {
      state: {
        student_name: studentName,
        student_id: id,
        course_name: courseName,
        class_name: className,
        admission_number: student?.admission_number,
      },
    })
  }

  const handleUpdate = (data) => {
    console.log('Data:', data)
    navigate(`/UpdateStudentProfile/${data.id}`, {
      state: {
        data,
        status: data.status.charAt(0).toUpperCase() + data.status.slice(1),
      },
    })
    console.log('Data:', data)
  }
  const exportToExcel = () => {
    const exportData = filteredData.map((student) => ({
      'Admission Number': student.admission_number,
      Name: student.name,
      // Age: student.age,
      // Gender: student.gender,
      'Father Name': student.father_name,
      // 'Mother Name': student.mother_name,
      'Admission Date': student.admission_date,
      Course: courses.find((c) => c.id === student.course_id)?.name || 'N/A',
      Class:
        classes.find((c) => c.id === student.class_id)?.class_name || 'N/A',
      'Parent Number': student.parents_number,
      // Email: student.email,
      // Address: student.address,
    }))

    const worksheet = XLSX.utils.json_to_sheet(exportData)

    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Students')

    XLSX.writeFile(workbook, 'Student_Records.xlsx')
  }
  // const handleRefresh = () => {
  //   setSelectedData({})
  //   setFilteredData(data) // Reset to original data
  //   setSearchAdmissionDate({})
  //   setSearch('')
  //   setSelectedClass(null)
  //   setData(students)
  //   setResetKey((prev) => prev + 1)
  // }
  const handleRefresh = () => {
    setSelectedData({}) // clears selected course/class/student
    setSearchAdmissionDate({})
    setFilteredData(data)
    setSearch('')
    setData(students) // or original unfiltered data
    setResetKey((prev) => prev + 1) // trigger reset in SelectableField
  }

  return (
    <>
      <style>
        {`
          .blinking-link {
            color: blue;
            text-decoration: none;
            cursor: pointer;
            animation: blink 1s infinite;
            font-weight:bold;
          }

          @keyframes blink {
            0% { color: blue; }
            50% { color: red; }
            100% { color: blue; }
          }

      `}
      </style>
      <div style={{ marginLeft }}>
        {/* Header */}

        <div
          className="container-fluid p-0"
          style={{
            marginTop: window.innerWidth < 768 ? '55px' : '-12px',
          }}
        >
          <div className="bg-secondary p-3 rounded d-flex flex-wrap justify-content-between align-items-center text-white">
            <h2>Students</h2>
            <Button
              variant="light"
              className="fw-bold"
              onClick={() => setShowModal(true)}
            >
              <People size={18} className="me-2" /> Add New Student
            </Button>
          </div>
        </div>

        <div className="mt-4">
          <Row className="g-3 mt-3 flex-nowrap">
            {user?.user_type !== 'teacher' && (
              <Col>
                <SelectableField
                  onSelect={handleSelect}
                  showCourse={true}
                  showClass={true}
                  showStudent={true}
                  abc={'abc'}
                  setData={setData}
                  resetTrigger={resetKey}
                />
              </Col>
            )}
          </Row>
        </div>
        <div>
          <Row>
            <Col
              xs={12}
              md={2}
              className="text-start"
              // style={{ marginLeft: '2rem' }}
            >
              <label className="fw-bold mb-2">Search Student Name</label>
              <Form.Control
                type="text"
                value={search}
                onChange={(e) => {
                  const value = e.target.value
                  setSearch(value)
                  const updatedSelection = { ...selectedData, student: value }
                  console.log('Search input:', value)
                  console.log('Updated Selection Object:', updatedSelection)
                  setSelectedData(updatedSelection)
                  fetchFilteredData(updatedSelection)
                }}
              />
            </Col>
            <Col xs={12} md={3} className="text-start">
              <label className="fw-bold mb-2">
                Search Student by Admission Date
              </label>
              <input
                type="date"
                value={searchAdmissionDate}
                onChange={(e) => {
                  setSearchAdmissionDate(e.target.value)
                  const newFilters = {
                    ...selectedData,
                    admission_date: e.target.value,
                  }
                  setSelectedData(newFilters)
                  fetchFilteredData(newFilters)
                }}
                className="form-control"
                placeholder="Search by Admission Date"
              />
            </Col>

            <Col className="d-flex justify-content-end align-items-center gap-2 mt-3">
              {user?.user_type !== 'teacher' && (
                <Button variant="outline-success" onClick={exportToExcel}>
                  <FaFileExcel /> Export to Excel
                </Button>
              )}
              <Button
                variant="outline-primary"
                onClick={handleRefresh}
                title="Refresh"
              >
                <FaSyncAlt /> Refresh
              </Button>
            </Col>
          </Row>
        </div>

        {/* Search & Items Per Page Selector */}
        <div className="d-flex justify-content-end align-items-center gap-3 mb-3 mt-2">
          <p className="text-black m-0">Total Students: {data.length}</p>
          <Form.Select
            className="w-auto"
            value={itemsPerPage}
            onChange={(e) => {
              setItemsPerPage(parseInt(e.target.value))
              setCurrentPage(1)
            }}
          >
            <option value="100">100 per page</option>
            <option value="200">200 per page</option>
            <option value="300">300 per page</option>
          </Form.Select>
        </div>

        {/* Table */}
        <Table className="table table-striped table-bordered table-hover rounded overflow-hidden shadow-sm mb-0">
          <Thead className="bg-dark text-white">
            <Tr className="bg-secondary rounded">
              <Th>Admission Number</Th>
              <Th>Name</Th>
              <Th>Father's Name</Th>
              <Th>Admission Date</Th>
              {/* <Th>Course</Th> */}
              {/* <Th>Class</Th> */}
              <Th>Parent's Number</Th>
              <Th>Action</Th>
            </Tr>
          </Thead>
          <Tbody>
            {data?.length > 0 || currentItems.length > 0 ? (
              [...(data?.length > 0 ? data : currentItems)]
                .sort(
                  (a, b) =>
                    new Date(b.admission_date) - new Date(a.admission_date),
                )
                .map((item, index) => (
                  <Tr key={index}>
                    <Td>{item.admission_number}</Td>
                    <Td>{item.name}</Td>
                    <Td>{item.father_name}</Td>
                    <Td>
                      {item.admission_date
                        ? new Date(item.admission_date).toLocaleDateString(
                            'en-GB',
                            {
                              day: '2-digit',
                              month: 'long',
                              year: 'numeric',
                            },
                          )
                        : 'N/A'}
                    </Td>
                    {/* <Td>
                      {courses.find((course) => course.id === item.course_id)
                        ?.name || 'N/A'}
                    </Td>{' '} */}
                    {/* <Td>
                      {' '}
                      {classes.find((cls) => cls.id === item.class_id)
                        ?.class_name || 'N/A'}
                    </Td>{' '} */}
                    <Td>{item.parents_number}</Td>
                    <Td className="text-center">
                      <div className="d-flex flex-wrap justify-content-start justify-content-md-center gap-2">
                        {user?.user_type !== 'teacher' && (
                          <Button
                            variant="info"
                            onClick={() => handleView(item.id)}
                            title="See Profile"
                          >
                            <Eye />
                          </Button>
                        )}

                        {user?.user_type !== 'teacher' && (
                          <Button
                            variant="warning"
                            onClick={() => handleUpdate(item)}
                            title="Update Info"
                          >
                            <FaUserEdit />
                          </Button>
                        )}

                        <Button
                          variant="secondary"
                          onClick={() => handleEnrolledCourses(item.id)}
                          title="Enrolled Courses"
                        >
                          <Book />
                        </Button>
                      </div>
                    </Td>
                  </Tr>
                ))
            ) : (
              <Tr>
                <Td colSpan="15" className="text-center">
                  No records found
                </Td>
              </Tr>
            )}
          </Tbody>
        </Table>

        {/* Pagination & Total Records */}
        <div className="d-flex justify-content-end align-items-center gap-3 mb-3 mt-4">
          <Pagination>
            <Pagination.Prev
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
            />
            {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
              <Pagination.Item
                key={page}
                active={page === currentPage}
                onClick={() => setCurrentPage(page)}
              >
                {page}
              </Pagination.Item>
            ))}
            <Pagination.Next
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
              }
              disabled={currentPage === totalPages || totalPages === 0}
            />
          </Pagination>
        </div>

        {/* Add Student Modal */}
        <Modal
          size="xl"
          show={showModal}
          onHide={() => setShowModal(false)}
          centered
        >
          <Modal.Header closeButton className="bg-secondary text-white">
            <Modal.Title>Add New Student</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={handleSave}>
              {/* Personal Details */}

              <Form.Group className="mb-3">
                <Form.Label>Name *</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  value={newStudent.name}
                  onChange={handleInputChange}
                  placeholder="Enter Student Name"
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Date of Birth *</Form.Label>
                <Form.Control
                  type="date"
                  name="dob"
                  value={newStudent.dob}
                  onChange={handleInputChange}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Age</Form.Label>
                <Form.Control
                  type="text"
                  name="age"
                  value={newStudent.age}
                  disabled
                  className="p-2 border rounded bg-light"
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Gender *</Form.Label>
                <Form.Select
                  name="gender"
                  value={newStudent.gender}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">Select</option>
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                </Form.Select>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Father's Name *</Form.Label>
                <Form.Control
                  type="text"
                  name="father_name"
                  value={newStudent.father_name}
                  onChange={handleInputChange}
                  placeholder="Enter Father's Name"
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Mother's Name *</Form.Label>
                <Form.Control
                  type="text"
                  name="mother_name"
                  value={newStudent.mother_name}
                  onChange={handleInputChange}
                  placeholder="Enter Mother's Name"
                />
              </Form.Group>

              {/* Admission Details */}

              <Form.Group className="mb-3">
                <Form.Label>Admission Date *</Form.Label>
                <Form.Control
                  type="date"
                  name="admission_date"
                  value={newStudent.admission_date}
                  onChange={handleInputChange}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Admission Number *</Form.Label>
                <Form.Control
                  type="text"
                  name="admission_number"
                  value={newStudent.admission_number}
                  onChange={handleInputChange}
                  required
                />
              </Form.Group>

              {/* Course & Schedule */}

              <Form.Group className="mb-3">
                <Form.Label>Course *</Form.Label>
                <Form.Select
                  name="course_id"
                  value={selectedNewCourse}
                  onChange={handleCourseChange}
                  required
                >
                  <option value="">Select Course</option>
                  {courses.map((course) => (
                    <option key={course.id} value={course.id}>
                      {course.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>

              {classes.length === 0 && selectedNewCourse && (
                <p style={{ color: 'red', letterSpacing: '1px' }}>
                  The selected course has no class. Please{' '}
                  <span
                    className="blinking-link"
                    onClick={handleNavigateToCreateClass}
                  >
                    click here
                  </span>{' '}
                  to create new class.
                </p>
              )}

              <Form.Group className="mb-3">
                <Form.Label>Class *</Form.Label>
                <Form.Select
                  name="class_id"
                  value={newStudent.class_id}
                  onChange={handleClassChange}
                  disabled={!courseTouched || classes.length === 0}
                >
                  <option value="">Select Class</option>
                  {classes.map((clas) => (
                    <option key={clas.id} value={clas.id}>
                      {clas.class_name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>

              {studentCount !== null && studentCount !== 'No data available' && (
                <div
                  style={{
                    color: countColor,
                    marginBottom: '5px',
                    fontWeight: 'bold',
                    letterSpacing: '1px',
                  }}
                >
                  {studentCount.current === null
                    ? `There are still ${studentCount.maximum_limit} seats available in this class.`
                    : studentCount.current === studentCount.maximum_limit
                    ? 'There are no more seats available in this class.'
                    : `There are ${
                        studentCount.maximum_limit - studentCount.current
                      } seats left in this class.`}
                </div>
              )}

              <FormGroup className="mb-3">
                <FormLabel>Institute *</FormLabel>
                <FormSelect
                  name="institute_id"
                  value={newStudent.institute_id}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">Select Institute</option>
                  {institutes.map((institute) => (
                    <option key={institute.id} value={institute.institute_id}>
                      {institute.name}
                    </option>
                  ))}
                </FormSelect>
              </FormGroup>

              <Form.Group className="mb-3">
                <Form.Label>ID Type</Form.Label>
                <Form.Select
                  name="id_proof_type"
                  value={newStudent.id_proof_type}
                  onChange={handleInputChange}
                >
                  <option value="">Select</option>
                  <option value="aadhar card">Aadhaar</option>
                  <option value="voter card">Voter ID</option>
                  <option value="license">License</option>
                </Form.Select>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>ID Proof Number</Form.Label>
                <Form.Control
                  type="number"
                  name="id_proof_number"
                  value={newStudent.id_proof_number}
                  onChange={handleInputChange}
                  placeholder="Enter Roll Number"
                />
              </Form.Group>

              {/* Contact Details */}

              <Form.Group className="mb-3">
                <Form.Label>Phone</Form.Label>
                <Form.Control
                  type="text"
                  name="phone"
                  value={newStudent.phone}
                  onChange={handleInputChange}
                  placeholder="Enter Phone Number"
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>WhatsApp Number (Optional)</Form.Label>
                <Form.Control
                  type="text"
                  name="whatsapp_number"
                  value={newStudent.whatsapp_number}
                  onChange={handleInputChange}
                  placeholder="Enter WhatsApp Number"
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Parent's Phone</Form.Label>
                <Form.Control
                  type="text"
                  name="parents_number"
                  value={newStudent.parents_number}
                  onChange={handleInputChange}
                  placeholder="Enter Parent's Phone Number"
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  value={newStudent.email}
                  onChange={handleInputChange}
                  placeholder="Enter Email"
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Address *</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  name="address"
                  value={newStudent.address}
                  onChange={handleInputChange}
                  placeholder="Enter Address"
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Student Image (PNG/JPG/JPEG)</Form.Label>

                <div className="d-flex align-items-center gap-3 mt-2 mb-2">
                  <Form.Control
                    type="file"
                    accept="student_image/png, student_image/jpeg, student_image/jpg"
                    onChange={(e) => setStudentImage(e.target.files[0])}
                    style={{ maxWidth: '700px' }}
                  />
                  {studentImage && (
                    <img
                      src={URL.createObjectURL(studentImage)}
                      alt="Preview"
                      style={{
                        width: 100,
                        height: 100,
                        objectFit: 'cover',
                        borderRadius: 8,
                        border: '1px solid #ccc',
                      }}
                    />
                  )}
                </div>
              </Form.Group>
              <Modal.Footer className="mb-4">
                <Button variant="danger" onClick={() => setShowModal(false)}>
                  Cancel
                </Button>
                <Button variant="success" type="submit">
                  Save Student
                </Button>
              </Modal.Footer>
            </Form>
          </Modal.Body>
        </Modal>
        <EditStudentModal
          show={showEditModal}
          handleClose={() => setShowEditModal(false)}
          studentData={selectedCourse}
        />
      </div>
    </>
  )
}

export default DataTable
